/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { useLocation } from 'react-router-dom';
import IconAktivasiManual from '../../icons/IconAkativasiManual';
import IconAturHET from '../../icons/IconAturHET';
import IconAudit from '../../icons/IconAudit';
import IconLogSyns from '../../icons/IconLogSyns';
import IconMyptmActivation from '../../icons/IconMyptmActivation';
import IconNotification from '../../icons/IconNotification';
import IconPermission from '../../icons/IconPermission';
import IconRegistrasiPangkalan from '../../icons/IconRegistrasiPangkalan';
import IconRole from '../../icons/IconRole';
import IconSettingFaq from '../../icons/IconSettingFaq';
import IconTerm from '../../icons/IconTerm';
import IconUser from '../../icons/IconUser';
import IconVerification from '../../icons/IconVerification';
import IconSettingMerchant from '../../icons/IconsettingMerchant';
import styles from './styles.scoped.css';
import IcUpdateStock from '../../icons/IcUpdateStock';
import IconMerchantNoOnboard from '../../icons/IconMerchantNoOnboard';
import { IconProfile } from '../../icons/IconProfile';
import IconSettingBusinessType from '../../icons/IconSettingBusinessType';
import IconSettingSubMerchant from '../../icons/IconSettingSubMerchant';
import IconSubMerchantActivation from '../../icons/IconSubMerchantActivation';
import IconAreaManagement from '../../icons/IconAreaManagement';
import IconUserExchange from '../../icons/IconUserExchange';
import IconLpgIn from '../../icons/IconLpgIn';
import IconArrowLeft from '../../icons/IconArrowLeft';
import IconLpgSync from '../../icons/IconLpgSync';
import IconUnblock from '../../icons/IconUnblock';
import IconSettingFeatureMerchant from '../../icons/IconSettingFeatureMerchant';
import IconInformasiBesaranSubsidi from '../../icons/IconInformasiBesaranSubsidi';

export function RenderIconBreadcrumbs() {
  const { pathname } = useLocation();
  const listIcon = [
    {
      icon: <IconRegistrasiPangkalan className={styles.breadCrumbsIcon} />,
      path: 'registrasi-pangkalan',
    },
    {
      icon: <IconAturHET className={styles.breadCrumbsIcon} />,
      path: 'price',
    },
    {
      icon: <IconSettingFaq className={styles.breadCrumbsIcon} />,
      path: 'faq',
    },
    {
      icon: <IconAudit className={styles.breadCrumbsIcon} />,
      path: 'audit-log',
    },
    {
      icon: <IconVerification className={styles.breadCrumbsIcon} />,
      path: 'verifikasi-data-merchant',
    },
    {
      icon: <IconVerification className={styles.breadCrumbsIcon} />,
      path: 'detail-verifikasi-data-merchant',
    },
    {
      icon: <IconLogSyns className={styles.breadCrumbsIcon} />,
      path: 'sinkronisasi-merchant',
      isChildPath: true
    },
    {
      icon: <IconSettingMerchant className={styles.breadCrumbsIcon} />,
      path: 'setting-data-merchant',
      isChildPath: true
    },
    {
      icon: <IconMerchantNoOnboard className={styles.breadCrumbsIcon} />,
      path: 'merchant-not-onboarding',
      isChildPath: true
    },
    {
      icon: <IconMyptmActivation className={styles.breadCrumbsIcon} />,
      path: 'aktivasi-mypertamina',
      isChildPath: true
    },
    {
      icon: <IcUpdateStock classname={'breadCrumbsIcon'} />,
      path: 'update-stock-merchant',
      isChildPath: true
    },
    {
      icon: <IconUser className={styles.breadCrumbsIcon} />,
      path: 'user',
    },
    {
      icon: <IconPermission className={styles.breadCrumbsIcon} />,
      path: 'permission',
    },
    {
      icon: <IconRole className={styles.breadCrumbsIcon} />,
      path: 'role',
    },
    {
      icon: <IconAktivasiManual className={styles.breadCrumbsIcon} />,
      path: 'aktivasi-pencatatan-manual',
      isChildPath: true
    },
    {
      icon: <IconTerm className={styles.breadCrumbsIcon} />,
      path: 'term-condition',
    },
    {
      icon: <IconNotification className={styles.breadCrumbsIcon} />,
      path: 'notification',
    },
    {
      icon: <IconProfile className={styles.breadCrumbsIcon} />,
      path: 'profile',
    },
    {
      icon: <IconSettingBusinessType className={styles.iconSettingBusinessType} />,
      path: 'business-type',
    },
    {
      icon: <IconSettingSubMerchant />,
      path: 'search',
    },
    {
      icon: <IconSettingSubMerchant />,
      path: 'detail',
    },
    {
      icon: <IconSubMerchantActivation />,
      path: 'registration-activation',
    },
    {
      icon: <IconAreaManagement />,
      path: 'area-management',
    },
    {
      icon: <IconUserExchange />,
      path: 'customer-setting',
    },
    {
      icon: <IconUserExchange />,
      path: 'province-transaction-restriction',
    },
    {
      icon: <IconLpgIn />,
      path: 'gigr-activation'
    },
    {
      icon: <IconArrowLeft />,
      path: 'activation-bulk'
    },
    {
      icon: <IconArrowLeft />,
      path: 'activation-by-merchant'
    },
    {
      icon: <IconLpgSync />,
      path: 'update-gr-merchant',
      isChildPath: true
    },
    {
      icon: <IconUnblock />,
      path: 'submission-unblock'
    },
    {
      icon: <IconSettingFeatureMerchant />,
      path: 'activation-feature-map'
    },
    {
      icon: <IconInformasiBesaranSubsidi className={styles.breadCrumbsIcon} />,
      path: 'subsidy-info'
    },
  ];

  const pathnames = pathname.split('/');
  const currentPathName = pathnames[1];
  return (
    <>
      {listIcon.map((val) => {
        if (currentPathName?.includes(val.path) ||
        (pathnames[2]?.includes(val.path) && val.isChildPath)) {
          return <span key={val.path}>{val.icon}</span>;
        }
      })}
    </>
  );
}
